import { PopoverItem, ToastContext, IToastContextProps } from '@enter/core';
import { mdiChevronDown } from '@mdi/js';
import copy from 'copy-text-to-clipboard';
import React from 'react';
import * as S from './claim-action-button.styles';

export interface IClaimActionButtonProps {
    className?: string;
    claimId: string;
    actions?: { label: string; onClick: (id: string) => Promise<void> | void }[];
}

export class ClaimActionButton extends React.Component<IClaimActionButtonProps> {
    public static contextType = ToastContext;
    public render(): React.ReactElement {
        return (
            <div onClick={this.stopPropagation}>
                <S.StyledPopover align="right" renderButton={this.renderButton}>
                    <PopoverItem onClick={this.copyLinkClick}>Copy link</PopoverItem>
                    {this.props.actions?.map((action, i) => {
                        const handleAction = () => action.onClick(this.props.claimId);

                        return (
                            <PopoverItem onClick={handleAction} key={i}>
                                {action.label}
                            </PopoverItem>
                        );
                    })}
                    {/*<PopoverItem>
                        <S.LinkItem to={`/patients/${this.props.claimId}`}>
                            View patient info
                        </S.LinkItem>
                    </PopoverItem>
                    <PopoverItem onClick={this.exportClaim}>Export claim</PopoverItem>
                    */}
                </S.StyledPopover>
            </div>
        );
    }

    private readonly stopPropagation = (e: React.MouseEvent): void => {
        e.stopPropagation();
    };

    private readonly renderButton = (): React.ReactElement => {
        return (
            <S.ActionButton className={this.props.className}>
                Action
                <S.ActionButtonIcon path={mdiChevronDown} />
            </S.ActionButton>
        );
    };

    private readonly copyLinkClick = (e: React.MouseEvent): void => {
        const { claimId } = this.props;
        // Extract accountId from URL
        const getAccountId = (): string | undefined => {
            const pathParts = window.location.pathname.split('/').filter(Boolean);
            return pathParts.length > 0 && pathParts[0].length === 36 ? pathParts[0] : undefined;
        };
        const accountId = getAccountId();
        const url = accountId 
            ? `${window.location.origin}/${accountId}/claims/${claimId}`
            : `${window.location.origin}/claims/${claimId}`;
        copy(url);
        (this.context as any).notify && (this.context as any).notify('Link copied to clipboard');
    };
}
